YP.UserSelector = function() {
    var $searchDivs         = $('.selector .search-result'), 
        $searchDiv          = $searchDivs.hide().first().show(),
        $friendsItems       = $('.selector .search-result .friend'),
        $selectedFriendsIds = [],
        $hiddenField        = $('.selector #selector_friend_ids'),
        $searchBox          = $('.selector .toolbar .search input'),
        $count              = $('.selector .selected-count');

    return {
        init: function() {
            $('.selector .toolbar select').change(function(){
                var $this = $(this),
                    val = $this.val(); 
                    $('.selector .search-result').hide().filter('.' + val).show();
                $searchBox.val('').trigger('keyup');
            });

            $('.selector .toolbar .search input').quicksearch('.selector .search-result .friend', {
                selector: '.info'
            });
            
            $('.selector .search-result .multiple').click(function(){
                var friends = $(this).parent('h5')
                                        .next('.friends')
                                        .find('.friend');

                if ($(this).is(':checked')) {
                    friends.each(function(){
                        $('.selector .search-result .' + $(this).attr('class').replace('friend ', '').replace('selected', '')).each(function(){
                            $(this).addClass('selected');
                        });
                    });
                } else {
                    friends.each(function(){
                        $('.selector .search-result .' + $(this).attr('class').replace('friend ', '').replace('selected', '')).each(function(){
                            $(this).removeClass('selected');
                        });
                    });
                }
                YP.UserSelector().update_friends_ids();
            });

            $friendsItems.on('click', function(){
                $('.selector .search-result .' + $(this).attr('class').replace('friend ', '').replace('selected', '')).each(function(){
                    YP.UserSelector().check_this_out($(this));
                });
                YP.UserSelector().update_friends_ids();
            });
        },
        array_unique: function(ar){
            if (ar.length && typeof ar !== 'string') {
                var sorter = {};
                var out = [];
                for (var i=0,j=ar.length;i<j;i++) {
                    if (!sorter[ar[i] + typeof ar[i]]) {
                        out.push(ar[i]);
                        sorter[ar[i] + typeof ar[i]] = true;
                    }
                }
            }
            return out || ar;
        },
        check_this_out: function(object) {
            if (object.hasClass('selected')) {
                object.removeClass('selected');
            } else {
                object.addClass('selected');
            }
            
        },
        update_friends_ids: function(){
            var ids = [];
            $searchDivs.find('.friend.selected').each(function(){
                ids.push($(this).attr('class').replace('friend user-', '').replace(' selected', '').replace(' ', ''));
            });
            ids = YP.UserSelector().array_unique(ids);

            $hiddenField.val(ids.join(','));
            $('.selector .search-result.selects').html('');
            for (id in ids) {
                $('.friend.user-'+ids[id]+':first').clone().prependTo('.selector .search-result.selects');
            }
            $count.html(ids.length + " selectionn&eacute;s");
        }
    }
};

window.addEventListener("load", function(){
    $('#main-modal').on('shown.bs.modal', function (e) {
        if($('#main-modal .selector').length) {
            YP.UserSelector().init();
        }
      
    })
});

